import { useTranslations } from "@/lib/static-intl";
import SolidButton from "../ui/Buttons/SolidButton";
import BgIcon from "../ui/icons/bg-icon";
import Span from "../ui/Span";

const CommentReporter = ({
  commentReportingOptions,
  toggleOption,
  createCommentReport,
  submitBtnLoader,
  resetReportModal,
}) => {
  const reportFeaturesT = useTranslations("report_features");

  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen z-[95] bg-black bg-opacity-50 inset-0 flex items-center justify-center backdrop-blur-sm"
      onClick={resetReportModal}
    >
      <button
        type="button"
        className="hidden md:block absolute z-[96] top-5 right-10 text-white text-xl"
        onClick={resetReportModal}
      >
        X
      </button>
      <div
        className="w-full max-h-[calc(100dvh-52px)] max-sm:relative max-sm:bottom-6 md:max-w-3xl md:min-w-[500px] md:max-h-[80vh] dark:bg-light_primary_label bg-dark_primary_label md:rounded-xl overflow-auto hide-scrollbar"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-full dark:bg-light_primary_label bg-dark_primary_label sticky top-0 left-0 flex items-center justify-start md:justify-center gap-5 px-5 md:px-0 py-5 border-b">
          <BgIcon
            icon={"charm:cross"}
            onClick={resetReportModal}
            className={"block md:hidden !w-8 !h-8 -ml-3"}
            IconclassName={"!w-7 h-5"}
          />
          <Span
            className={
              "sticky top-0 left-0 !text-[18px] !font-[600] !leading-[19px]"
            }
          >
            {reportFeaturesT("report_comment")}
          </Span>
        </div>
        <div className="w-full py-2 px-4 flex flex-col max-h-full">
          {commentReportingOptions.map((_op, i) => (
            <div
              key={i}
              className="w-full group flex items-center justify-between gap-5 cursor-pointer py-5 hover:bg-gray-50 dark:hover:bg-brown transition rounded-lg px-4"
              onClick={() => toggleOption(i)}
            >
              <Span
                className={"!text-[16px] !font-[400] group-hover:text-black dark:group-hover:text-white"}
              >
                {reportFeaturesT(_op?.option)}
              </Span>
              <input
                type="checkbox"
                checked={_op?.isSelected}
                defaultChecked={_op?.isSelected}
                className="accent-red h-4 w-4"
              />
            </div>
          ))}
        </div>
        <div className="w-full dark:bg-light_primary_label bg-dark_primary_label sticky bottom-0 left-0 flex items-center justify-center py-3 border-t">
          <SolidButton onClick={createCommentReport} loading={submitBtnLoader}>
            {reportFeaturesT("submit")}
          </SolidButton>
        </div>
      </div>
    </div>
  );
};

export default CommentReporter;
